let initialized = false;

const ADS_ID = 'AW-11508016849';
export const CONSENT_STORAGE_KEY = 'goldmann-consent-v2';

export type ConsentStatus = 'accepted' | 'rejected' | 'unset';

export function getStoredConsent(): ConsentStatus {
  if (typeof window === 'undefined') return 'unset';

  const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
  if (value === 'accepted' || value === 'rejected') return value;

  return 'unset';
}

export function hasMarketingConsent() {
  return getStoredConsent() === 'accepted';
}

function ensureDataLayer() {
  if (typeof window === 'undefined') return;

  (window as any).dataLayer = (window as any).dataLayer || [];

  function gtag() {
    (window as any).dataLayer.push(arguments);
  }

  (window as any).gtag = (window as any).gtag || gtag;
}

export function setConsentDefault() {
  if (typeof window === 'undefined') return;

  ensureDataLayer();

  (window as any).gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });
}

export function updateConsentGranted() {
  if (typeof window === 'undefined') return;

  ensureDataLayer();

  if (!initialized) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
    document.head.appendChild(script);

    (window as any).gtag('js', new Date());

    (window as any).gtag('config', ADS_ID, {
      anonymize_ip: true,
      allow_google_signals: false,
    });

    initialized = true;
  }

  (window as any).gtag('consent', 'update', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  });
}

export function updateConsentDenied() {
  if (typeof window === 'undefined') return;

  ensureDataLayer();

  (window as any).gtag('consent', 'update', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}
